import { z } from 'zod';

export const countrySchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  regionId: z.string(),
});

export type Country = z.infer<typeof countrySchema>;
